import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BaseApiService } from '../base-api.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { IMyDpOptions, IMyDateModel, IMyDate } from 'mydatepicker';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css']
})
export class NotificationComponent implements OnInit {
  @ViewChild('form') form;
  selectedCategory: string;
  files: FileList;
  tab_name: string;
  title: string;
  description: string;
  startDate: string;
  endDate: string;
  //=========Edit Notification===========
  editNotificationId: string;
  editNotificationTitle: string;
  editNotificationDescription: string;
  editNotificationTypeId:string;
  editNotificationType:string;
  editNotificationCreatedBy:string;
  isChecked =false;
  isChecked1 =false;
  editPublication: string;
  editStartDate:string;
  editEndDate:string;
  editFiles: FileList;
editNotificationRigions:string;
editNotificationStates:string;
editNotificationCities:string;
editNotificationDealers:string;
editNotificationDivisions:string;

  private rigions: Array<any> = [];
  private tab_data: Array<any> = [];
  private tab_data_Ids: Array<any> = [];
  private states: Array<any> = [];
  private cities: Array<any> = [];
  private dealers: Array<any> = [];
  private divisions: Array<any> = [];
  selectedRigion: any;
  selectedState: any;
  selectedCity: any;
  selectedDealer: any;
  selectedDivision: any;
  body: any;
  publication: string;
  notificationTypeId: string;
  private data_NOTIFICATION: Array<any> = [];
  private data_READ_NOTIFICATION: Array<any> = [];

  public myDate: IMyDate = {

    year: this.getCurrentDay('Y'),
    month: this.getCurrentDay('M'),
    day: this.getCurrentDay('D'),
  }
  getCurrentDay(cat): any {
    let output;
    var today = new Date();
    var day = today.getDate();
    if (day != 1) {
      day = day - 1;
    }

    var month = today.getMonth() + 1; //January is 0!
    var year = today.getFullYear();

    if (cat === 'D') {
      output = day;
    }
    else if (cat === 'M') {
      output = month;
    }
    else {
      output = year;
    }
    return output;
  }
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'yyyy-mm-dd',
    markCurrentDay: true,
    disableUntil: this.myDate

  };
  public model: any = { date: { year: 2018, month: 10, day: 9 } };
  dropdownOpen = false; 

  constructor(private router: Router, private baseAPI: BaseApiService, private spinnerService: Ng4LoadingSpinnerService) {

    var token = localStorage.getItem('token');
    if (token == undefined || token === '') {
      this.router.navigate(['/login']);
    }
    this.length_NOTIFICATION = this.data_NOTIFICATION.length;
  }
  uploadMaster() {
    this.router.navigate(['/uploadMaster']);
  }
  dashboard() {
    this.router.navigate(['/dashboard']);
  }
  viewMaster() {
    this.router.navigate(['/viewMaster']);
  }
  userPositions() {
    this.router.navigate(['/userPosition']);
  }
  ngOnInit() {
    var token = localStorage.getItem('token');
    this.hideAllView();
    if (token == undefined || token === '') {
      this.router.navigate(['/login']);
    }

    this.selectedCategory = 'Choose Notification category';

  }
  hideAllView() {
    this.dropdownOpen=false
    document.getElementById('addNotification').style.display = 'none';
    document.getElementById('editNotification').style.display = 'none';
    document.getElementById('notification_table').style.display = 'none';
    document.getElementById('read_notification_table').style.display = 'none';
    document.getElementById('state_bt').style.display = 'none';
    document.getElementById('city_bt').style.display = 'none';
    document.getElementById('dealer_bt').style.display = 'none';
    document.getElementById('division_bt').style.display = 'none';
    this.data_NOTIFICATION = [];
    this.rigions = [];
    this.states = [];
    this.cities = [];
    this.dealers = [];
    this.divisions = [];
    this.selectedRigion = '';
    this.selectedState = '';
    this.selectedCity = '';
    this.selectedDealer = '';
    this.selectedDivision = '';

    this.tab_name = '';
    this.tab_data = [];
    this.title = '';
    this.description = '';


  }
  category = [
    { index: '1', viewValue: 'Add Notification' },
    { index: '2', viewValue: 'View Notification' }

  ];
  listClick(event: any, newValue) {
    
    event.preventDefault();

    this.selectedCategory = newValue;

    if (this.selectedCategory == this.category[0].viewValue) {
      this.hideAllView();
      this.selectedCategory='Add Notification'
      this.callRigionApi();

    }
    else if (this.selectedCategory == this.category[1].viewValue) {
      this.hideAllView();
      this.selectedCategory='View Notification'
      this.spinnerService.show();
      this.callViewNotificationApi();

    }

  }

  isInvalidInput(value: string): boolean {
    const pattern = /<\s*script\b[^>]*>.*?<\s*\/\s*script\s*>|<[^>]+>|\b(select|insert|update|delete|drop|union|exec|truncate|alter|create|grant|revoke)\b/i;
    return pattern.test(value);
  }

  saveNotification() {

    if ((this.startDate === undefined || this.startDate === '' || this.startDate === null) ||
      (this.endDate === undefined || this.endDate === '' || this.endDate === null) ||
      (this.tab_name === undefined || this.tab_name === '') ||
      (this.title === undefined || this.title === '') ||
      (this.publication === undefined || this.publication === '') ||
      (this.description === undefined || this.description === '') ||
      (this.selectedRigion === undefined || this.selectedRigion.length == 0) ||
      (this.selectedState === undefined || this.selectedState.length == 0) ||
      (this.selectedCity === undefined || this.selectedCity.length == 0) ||
      (this.selectedDealer === undefined || this.selectedDealer.length == 0) ||
      (this.selectedDivision === undefined || this.selectedDivision.length == 0) ||
      (this.description === undefined || this.description === '')) {
      alert('Please fill all mandatory fields.');

    
    }
    else {
      if (this.isInvalidInput(this.title) || this.isInvalidInput(this.description)) {
        alert('Invalid characters detected. HTML tags, SQL queries are not allowed.');
      
      } else {
      this.notificationTypeId = '';
      if (this.tab_data != undefined && this.tab_data.length != undefined) {
        for (let i = 0; i < this.tab_data.length; i++) {
          if (this.tab_name === this.tab_data[i]) {
            this.notificationTypeId = this.tab_data_Ids[i];
          }
          else {
            this.notificationTypeId = '';
          }
        }
      }
      this.callSaveNotificationApi();
    }


    }




  }
  onStartDateChanged(event: IMyDateModel) {
    this.startDate = event.formatted;
    console.log(this.startDate);

    //if(this.startDate===undefined){alert("Please enter valid date");this.startDate=null;return false;}

    var today = new Date();

    if (this.startDate != null) {
      //	alert(this.startDate+' '+today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds());

    } else {

      //this.startDate = today.getFullYear()+'-'+(((today.getMonth()+1)<10?'0'+(today.getMonth()+1) : (today.getMonth()+1)))+'-'+today.getDate()+' '+today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

      this.startDate = today.getFullYear() + '-' + (((today.getMonth() + 1) < 10 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1))) + '-' + today.getDate();

      //alert(today.getFullYear()+'-'+(((today.getMonth()+1)<10?'0'+(today.getMonth()+1) : (today.getMonth()+1)))+'-'+today.getDate()+' '+today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds());
    }

    if (this.endDate != null && this.startDate != null) {
      this.compareDate();
    }

  }


  onEndDateChanged(event: IMyDateModel) {
    this.endDate = event.formatted;

    var today = new Date();

    if (this.endDate != null) {
      //	alert(this.endDate+' '+today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds());

    } else {

      //this.endDate = today.getFullYear()+'-'+(((today.getMonth()+1)<10?'0'+(today.getMonth()+1) : (today.getMonth()+1)))+'-'+today.getDate()+' 23:59:59';

      this.endDate = today.getFullYear() + '-' + (((today.getMonth() + 1) < 10 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1))) + '-' + today.getDate();

      //alert(today.getFullYear()+'-'+(((today.getMonth()+1)<10?'0'+(today.getMonth()+1) : (today.getMonth()+1)))+'-'+today.getDate()+' '+today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds());

    }

    if (this.endDate != null && this.startDate != null) {
      this.compareDate();
    }
  }
  checked(value) {
    this.publication = value;
  }
  getFiles(event) {
    this.files = event.target.files;
    // console.log(this.files);
    if (this.files != undefined && this.files != null) {
      for (var i = 0; i < this.files.length; i++) {
        var fileSize = this.files[i].size;

        if (fileSize >= 5242880) {
          alert('Please select a file below 5MB');
          this.refreshPage();
        }
      }

    }

  }

  compareDate(){
    var startDate = new Date(this.startDate);
    var endDate = new Date(this.endDate);

    if (endDate < startDate) {
      alert("Start date should not be greater than Expiry date");
      this.startDate = null;
      this.endDate = null;
    }
  }

  compareDate1(){
    var startDate = new Date(this.editStartDate);
    var endDate = new Date(this.editEndDate);

    if (endDate < startDate) {
      alert("Start date should not be greater than Expiry date");
      this.editStartDate = null;
      this.editEndDate = null;
    }
  }

  reset2() {
    this.files = null;
    this.editFiles=null;
    this.form.nativeElement.reset();
    this.tab_name = '';
    this.title = '';
    this.description = '';
    this.startDate = '';
    this.endDate = '';
    this.states = [];
    this.cities = [];
    this.dealers = [];
    this.divisions = [];
    this.selectedState = '';
    this.selectedCity = '';
    this.selectedDealer = '';
    this.selectedDivision = ''

    document.getElementById('state_bt').style.display = 'block';
    document.getElementById('city_bt').style.display = 'none';
    document.getElementById('dealer_bt').style.display = 'none';
    document.getElementById('division_bt').style.display = 'none';

  }
  refreshPage() {
    this.files = null;
    this.editFiles=null;
    this.form.nativeElement.reset();
  }
  onChangeRigion(deviceValue) {
    document.getElementById('state_bt').style.display = 'block';
    document.getElementById('city_bt').style.display = 'none';
    document.getElementById('dealer_bt').style.display = 'none';
    document.getElementById('division_bt').style.display = 'none';
    this.states = [];
    this.cities = [];
    this.dealers = [];
    this.divisions = [];
    this.selectedState = '';
    this.selectedCity = '';
    this.selectedDealer = '';
    this.selectedDivision = '';
  }
  onChangeState(deviceValue) {
    document.getElementById('city_bt').style.display = 'block';
    document.getElementById('dealer_bt').style.display = 'none';
    document.getElementById('division_bt').style.display = 'none';

    this.cities = [];
    this.dealers = [];
    this.divisions = [];
    this.selectedCity = '';
    this.selectedDealer = '';
    this.selectedDivision = '';
  }
  onChangeCity(deviceValue) {
    document.getElementById('dealer_bt').style.display = 'block';
    document.getElementById('division_bt').style.display = 'none';
    this.dealers = [];
    this.divisions = [];
    this.selectedDealer = '';
    this.selectedDivision = '';
  }
  onChangeDealer(deviceValue) {
    document.getElementById('division_bt').style.display = 'block';
    this.divisions = [];
    this.selectedDivision = '';
  }

  getSates() {
    if (this.selectedRigion != undefined && this.selectedRigion.length > 0) {
      this.callStateApi();
    }
    else {
      alert('Please select rigions first.');
    }
  }
  getCities() {
    if (this.selectedState != undefined && this.selectedState.length > 0) {
      this.callCityApi();
    }
    else {
      alert('Please select state first.');
    }
  }
  getDealers() {
    if (this.selectedCity != undefined && this.selectedCity.length > 0) {
      this.callDealerApi();
    }
    else {
      alert('Please select state first.');
    }
  }
  getDivisions() {
    if (this.selectedDealer != undefined && this.selectedDealer.length > 0) {
      this.callDivisionApi();
    }
    else {
      alert('Please select state first.');
    }
  }
  //====================================View Notification==================================
  public rows_NOTIFICATION: Array<any> = [];

  public columns_NOTIFICATION: Array<any> = [
    { title: 'Id', name: 'notification_id' },
    { title: 'Notification Type', name: 'notfi_type' },
    { title: 'Notification Title', name: 'notification_title' },
    { title: 'Notification Description', name: 'notification_desc' },
    { title: 'Start Date', name: 'start_date' },
    { title: 'End Date', name: 'end_date' },
    { title: 'Rigions', name: 'regions' },
    { title: 'States', name: 'states' },
    { title: 'Cities', name: 'cities' },
    { title: 'Dealers', name: 'dealers' },
    { title: 'Divisions', name: 'divisions' },
    { title: 'Images', name: 'notif_images' },
    { title: 'Is Published', name: 'is_published' },
    { title: 'Read details', name: 'read_button' },
    { title: 'Edit', name: 'edit_button' },
    { title: 'Delete', name: 'delete_button' }
  ];

  public page_NOTIFICATION: number = 1;
  public itemsPerPage_NOTIFICATION: number = 5000;
  public maxSize_NOTIFICATION: number = 5;
  public numPages_NOTIFICATION: number = 1;
  public length_NOTIFICATION: number = 0;


  public config_NOTIFICATION: any = {
    paging: true,
    sorting: { columns: this.columns_NOTIFICATION },
    filtering: { filterString: '' },
    className: ['table-striped', 'table-bordered']
  };


  public changePage_NOTIFICATION(page_NOTIFICATION: any, data_NOTIFICATION: Array<any> = this.data_NOTIFICATION): Array<any> {

    let start = (page_NOTIFICATION.page - 1) * page_NOTIFICATION.itemsPerPage;

    let end = page_NOTIFICATION.itemsPerPage > -1 ? (start + page_NOTIFICATION.itemsPerPage) : data_NOTIFICATION.length;
    return data_NOTIFICATION.slice(start, end);

  }

  public changeSort_NOTIFICATION(data_NOTIFICATION: any, config_NOTIFICATION: any): any {
    if (!config_NOTIFICATION.sorting) {
      return data_NOTIFICATION;
    }

    let columns_NOTIFICATION = this.config_NOTIFICATION.sorting.columns_NOTIFICATION || [];
    let columnName_NOTIFICATION: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns_NOTIFICATION.length; i++) {
      if (columns_NOTIFICATION[i].sort !== '' && columns_NOTIFICATION[i].sort !== false) {
        columnName_NOTIFICATION = columns_NOTIFICATION[i].name;
        sort = columns_NOTIFICATION[i].sort;
      }
    }

    if (!columnName_NOTIFICATION) {
      return data_NOTIFICATION;
    }

    // simple sorting
    return data_NOTIFICATION.sort((previous: any, current: any) => {
      if (previous[columnName_NOTIFICATION] > current[columnName_NOTIFICATION]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName_NOTIFICATION] < current[columnName_NOTIFICATION]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter_NOTIFICATION(data_NOTIFICATION: any, config_NOTIFICATION: any): any {
    let filteredData: Array<any> = data_NOTIFICATION;
    this.columns_NOTIFICATION.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config_NOTIFICATION.filtering) {
      return filteredData;
    }

    if (config_NOTIFICATION.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config_NOTIFICATION.filtering.columnName].match(this.config_NOTIFICATION.filtering.filterString));
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns_NOTIFICATION.forEach((column: any) => {
        if (item[column.name].toString().match(this.config_NOTIFICATION.filtering.filterString)) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChangeTable_NOTIFICATION(config_NOTIFICATION: any, page: any = { page: this.page_NOTIFICATION, itemsPerPage: this.itemsPerPage_NOTIFICATION }): any {


    if (config_NOTIFICATION.filtering) {
      Object.assign(this.config_NOTIFICATION.filtering, config_NOTIFICATION.filtering);
    }

    if (config_NOTIFICATION.sorting) {
      Object.assign(this.config_NOTIFICATION.sorting, config_NOTIFICATION.sorting);
    }

    let filteredData = this.changeFilter_NOTIFICATION(this.data_NOTIFICATION, this.config_NOTIFICATION);
    let sortedData = this.changeSort_NOTIFICATION(filteredData, this.config_NOTIFICATION);

    this.rows_NOTIFICATION = page && config_NOTIFICATION.paging ? this.changePage_NOTIFICATION(page, sortedData) : sortedData;
    this.length_NOTIFICATION = sortedData.length;

  }

  public onCellClick_NOTIFICATION(data: any): any {
    if (data.column == 'delete_button') {
      var obj = Object.assign(data);
      console.log(obj);
      var notificationId = obj.row.notification_id;
      this.deleteNotificationApi(notificationId);

    }
    else if (data.column == 'read_button') {
      var obj = Object.assign(data);

      var notificationId = obj.row.notification_id;
      this.hideAllView();
      this.selectedCategory = 'Read Notification';
      this.spinnerService.show();
      this.callReadNotificationApi(notificationId);
    }
    else if (data.column == 'edit_button') {
      var obj = Object.assign(data);

      var notificationId = obj.row.notification_id;
      this.hideAllView();
      this.selectedCategory = 'Edit Notification';
      this.spinnerService.show();
      this.callGetNotificationById(notificationId);
    }
  }


  //====================================READ Notification==================================
  public rows_READ_NOTIFICATION: Array<any> = [];

  public columns_READ_NOTIFICATION: Array<any> = [

    { title: 'Notification Id', name: 'notification_id' },
    { title: 'User Id', name: 'user_id' },
    { title: 'User Dealer', name: 'user_dealer' },
    { title: 'User State', name: 'user_state' },
    { title: 'User City', name: 'user_city' },
    { title: 'User Region', name: 'user_region' },
    { title: 'User Division Name', name: 'user_div_name' },
    { title: 'User Name', name: 'user_name' },
    { title: 'Read flag', name: 'read_flag' },
    { title: 'Read date', name: 'read_date' }
  ];

  public page_READ_NOTIFICATION: number = 1;
  public itemsPerPage_READ_NOTIFICATION: number = 10000;
  public maxSize_READ_NOTIFICATION: number = 5;
  public numPages_READ_NOTIFICATION: number = 1;
  public length_READ_NOTIFICATION: number = 0;


  public config_READ_NOTIFICATION: any = {
    paging: true,
    sorting: { columns: this.columns_READ_NOTIFICATION },
    filtering: { filterString: '' },
    className: ['table-striped', 'table-bordered']
  };


  public changePage_READ_NOTIFICATION(page_READ_NOTIFICATION: any, data_READ_NOTIFICATION: Array<any> = this.data_READ_NOTIFICATION): Array<any> {

    let start = (page_READ_NOTIFICATION.page - 1) * page_READ_NOTIFICATION.itemsPerPage;

    let end = page_READ_NOTIFICATION.itemsPerPage > -1 ? (start + page_READ_NOTIFICATION.itemsPerPage) : data_READ_NOTIFICATION.length;
    return data_READ_NOTIFICATION.slice(start, end);

  }

  public changeSort_READ_NOTIFICATION(data_READ_NOTIFICATION: any, config_READ_NOTIFICATION: any): any {
    if (!config_READ_NOTIFICATION.sorting) {
      return data_READ_NOTIFICATION;
    }

    let columns_READ_NOTIFICATION = this.config_READ_NOTIFICATION.sorting.columns_READ_NOTIFICATION || [];
    let columnName_READ_NOTIFICATION: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns_READ_NOTIFICATION.length; i++) {
      if (columns_READ_NOTIFICATION[i].sort !== '' && columns_READ_NOTIFICATION[i].sort !== false) {
        columnName_READ_NOTIFICATION = columns_READ_NOTIFICATION[i].name;
        sort = columns_READ_NOTIFICATION[i].sort;
      }
    }

    if (!columnName_READ_NOTIFICATION) {
      return data_READ_NOTIFICATION;
    }

    // simple sorting
    return data_READ_NOTIFICATION.sort((previous: any, current: any) => {
      if (previous[columnName_READ_NOTIFICATION] > current[columnName_READ_NOTIFICATION]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName_READ_NOTIFICATION] < current[columnName_READ_NOTIFICATION]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter_READ_NOTIFICATION(data_READ_NOTIFICATION: any, config_READ_NOTIFICATION: any): any {
    let filteredData: Array<any> = data_READ_NOTIFICATION;
    this.columns_READ_NOTIFICATION.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config_READ_NOTIFICATION.filtering) {
      return filteredData;
    }

    if (config_READ_NOTIFICATION.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config_READ_NOTIFICATION.filtering.columnName].match(this.config_READ_NOTIFICATION.filtering.filterString));
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns_READ_NOTIFICATION.forEach((column: any) => {
        if (item[column.name].toString().match(this.config_READ_NOTIFICATION.filtering.filterString)) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChangeTable_READ_NOTIFICATION(config_READ_NOTIFICATION: any, page: any = { page: this.page_READ_NOTIFICATION, itemsPerPage: this.itemsPerPage_READ_NOTIFICATION }): any {


    if (config_READ_NOTIFICATION.filtering) {
      Object.assign(this.config_READ_NOTIFICATION.filtering, config_READ_NOTIFICATION.filtering);
    }

    if (config_READ_NOTIFICATION.sorting) {
      Object.assign(this.config_READ_NOTIFICATION.sorting, config_READ_NOTIFICATION.sorting);
    }

    let filteredData = this.changeFilter_READ_NOTIFICATION(this.data_READ_NOTIFICATION, this.config_READ_NOTIFICATION);
    let sortedData = this.changeSort_READ_NOTIFICATION(filteredData, this.config_READ_NOTIFICATION);

    this.rows_READ_NOTIFICATION = page && config_READ_NOTIFICATION.paging ? this.changePage_READ_NOTIFICATION(page, sortedData) : sortedData;
    this.length_NOTIFICATION = sortedData.length;

  }

  public onCellClick_READ_NOTIFICATION(data: any): any {

  }


  //  ================================Edit Notification==========================================

  editChecked(value) {
    this.editPublication = value;
  }
  updateNotification(){
    if(this.editPublication===''|| this.editPublication==undefined){
      if(this.isChecked==true){
        this.editPublication='Y';
      }
      else if(this.isChecked1==true){
        this.editPublication='N';
      }
    }
    if ((this.editStartDate === undefined || this.editStartDate === '' || this.editStartDate === null) ||
    (this.editEndDate === undefined || this.editEndDate === '' || this.editEndDate === null) ||

    (this.editPublication === undefined || this.editPublication === '') ||
    (this.editNotificationId === undefined || this.editNotificationId === '') ||
    (this.editNotificationTitle === undefined || this.editNotificationTitle === '') ||

    (this.editNotificationDescription === undefined || this.editNotificationDescription === '')) {
    alert('Please fill all mandatory fields.');
  }
  else {
    this.callUpdateNotificationApi();



  }


  }
  onEditStartDateChanged(event: IMyDateModel) {

    //let shadesEl = document.querySelector('.selection ng-valid ng-touched ng-dirty invaliddate');

    //alert(shadesEl.classList);
    //shadesEl.classList.remove('invaliddate');

    this.editStartDate = event.formatted;

    //if(this.editStartDate===undefined){alert("Please enter valid date");this.editStartDate=null;return false;}

    var today = new Date();

    if (this.editStartDate != null) {
      //	alert(this.editStartDate+' '+today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds());

    } else {

      //this.editStartDate = today.getFullYear()+'-'+(((today.getMonth()+1)<10?'0'+(today.getMonth()+1) : (today.getMonth()+1)))+'-'+today.getDate()+' '+today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

      this.editStartDate = today.getFullYear() + '-' + (((today.getMonth() + 1) < 10 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1))) + '-' + today.getDate();

      //alert(today.getFullYear()+'-'+(((today.getMonth()+1)<10?'0'+(today.getMonth()+1) : (today.getMonth()+1)))+'-'+today.getDate()+' '+today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds());
    }

    if (this.editEndDate != null && this.editStartDate != null) {
      this.compareDate1();
    }

  }


  onEditEndDateChanged(event: IMyDateModel) {
    this.editEndDate = event.formatted;

    var today = new Date();

    if (this.editEndDate != null) {
      //	alert(this.editEndDate+' '+today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds());

    } else {

      //this.editEndDate = today.getFullYear()+'-'+(((today.getMonth()+1)<10?'0'+(today.getMonth()+1) : (today.getMonth()+1)))+'-'+today.getDate()+' 23:59:59';

      this.editEndDate = today.getFullYear() + '-' + (((today.getMonth() + 1) < 10 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1))) + '-' + today.getDate();

      //alert(today.getFullYear()+'-'+(((today.getMonth()+1)<10?'0'+(today.getMonth()+1) : (today.getMonth()+1)))+'-'+today.getDate()+' '+today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds());

    }

    if (this.editEndDate != null && this.editStartDate != null) {
      this.compareDate1();
    }

  }

getEditFiles(event){
  this.editFiles = event.target.files;
  if (this.editFiles != undefined && this.editFiles != null) {
    for (var i = 0; i < this.editFiles.length; i++) {
      var fileSize = this.editFiles[i].size;

      if (fileSize >= 5242880) {
        alert('Please select a file below 5MB');
        this.refreshPage();
      }
    }

  }
}

  //===============================================API===============================================

  callRigionApi() {
    this.spinnerService.show();
    this.body = {
      "BU": "TMPC"
    };
    this.baseAPI.callLocationsApi(this.body, this.baseAPI.regionURL).then(data => {

      var jsonObj = JSON.parse(JSON.stringify(data));
      this.rigions.push('All');
      var rigionArray = jsonObj.regions;
      if (rigionArray.length > 0) {
        for (var i = 0; i < rigionArray.length; i++) {
          this.rigions.push(rigionArray[i]);
        }
      }

      this.callGetNotificationTypeApi();



    }, (err) => {

      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));
      document.getElementById('addNotification').style.display = 'none';
      var message = jsonObj.msg;
      if (message != undefined) {
        alert(message);
      }
      else {
        alert('Please try again');
      }
    });
  }
  callGetNotificationTypeApi() {


    this.baseAPI.callGetNotificationTypeApi(this.baseAPI.notificationTypeURL).then(data => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(data));

      var notificationTypeArray = jsonObj.notification_types;
      if (notificationTypeArray.length > 0) {
        for (var i = 0; i < notificationTypeArray.length; i++) {
          this.tab_data.push(notificationTypeArray[i].notif_type);
          this.tab_data_Ids.push(notificationTypeArray[i].notif_type_id);
        }
      }
      document.getElementById('addNotification').style.display = 'block';
    }, (err) => {
      console.log('Here');
      this.spinnerService.hide();
      document.getElementById('addNotification').style.display = 'block';


    });
  }

  callStateApi() {
    this.spinnerService.show();
    this.states = [];
    this.body = {
      "regions": this.selectedRigion
    };
    this.baseAPI.callLocationsApi(this.body, this.baseAPI.stateURL).then(data => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(data));

      this.states.push('All');
      var stateArray = jsonObj.states;
      if (stateArray.length > 0) {
        for (var i = 0; i < stateArray.length; i++) {
          this.states.push(stateArray[i]);
        }
      }



    }, (err) => {

      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));
      var message = jsonObj.msg;
      if (message != undefined) {
        alert(message);
      }
      else {
        alert('Please try again');
      }
    });
  }
  callCityApi() {
    this.spinnerService.show();
    this.cities = [];
    this.body = {
      "regions": this.selectedRigion,
      "states": this.selectedState
    };
    this.baseAPI.callLocationsApi(this.body, this.baseAPI.cityURL).then(data => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(data));

      this.cities.push('All');
      var cityeArray = jsonObj.cities;
      if (cityeArray.length > 0) {
        for (var i = 0; i < cityeArray.length; i++) {
          this.cities.push(cityeArray[i]);
        }
      }
    }, (err) => {

      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));
      var message = jsonObj.msg;
      if (message != undefined) {
        alert(message);
      }
      else {
        alert('Please try again');
      }
    });
  }

  callDealerApi() {
    this.spinnerService.show();
    this.dealers = [];
    this.body = {
      "regions": this.selectedRigion,
      "states": this.selectedState,
      "cities": this.selectedCity
    };
    this.baseAPI.callLocationsApi(this.body, this.baseAPI.dealerURL).then(data => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(data));

      this.dealers.push('All');
      var dealerArray = jsonObj.dealers;
      if (dealerArray.length > 0) {
        for (var i = 0; i < dealerArray.length; i++) {
          this.dealers.push(dealerArray[i]);
        }
      }
    }, (err) => {

      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));
      var message = jsonObj.msg;
      if (message != undefined) {
        alert(message);
      }
      else {
        alert('Please try again');
      }
    });
  }

  callDivisionApi() {
    this.spinnerService.show();
    this.divisions = [];
    this.body = {
      "regions": this.selectedRigion,
      "states": this.selectedState,
      "cities": this.selectedCity,
      "dealers": this.selectedDealer

    };
    this.baseAPI.callLocationsApi(this.body, this.baseAPI.divisionURL).then(data => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(data));

      this.divisions.push('All');
      var divisionArray = jsonObj.divisions;
      if (divisionArray.length > 0) {
        for (var i = 0; i < divisionArray.length; i++) {
          this.divisions.push(divisionArray[i]);
        }
      }
    }, (err) => {

      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));
      var message = jsonObj.msg;
      if (message != undefined) {
        alert(message);
      }
      else {
        alert('Please try again');
      }
    });
  }

  callSaveNotificationApi() {
    this.spinnerService.show();
    let formData: FormData = new FormData();
    formData.append('notification_type', this.tab_name);
    formData.append('notification_title', this.title);
    formData.append('notification_desc', this.description);
    formData.append('start_date', this.startDate);
    formData.append('end_date', this.endDate);
    formData.append('is_published', this.publication);
    formData.append('notif_type_id', this.notificationTypeId);
    //Images
    if (this.files != undefined && this.files.length != undefined) {
      for (let i = 0; i < this.files.length; i++) {
        formData.append('files', this.files[i]);
      }
    }
    //Rigion

    for (let i = 0; i < this.selectedRigion.length; i++) {
      formData.append('regions', this.selectedRigion[i]);
    }
    //State
    for (let i = 0; i < this.selectedState.length; i++) {
      formData.append('states', this.selectedState[i]);
    }


    //City

    for (let i = 0; i < this.selectedCity.length; i++) {
      formData.append('cities', this.selectedCity[i]);
    }

    //Dealers

    for (let i = 0; i < this.selectedDealer.length; i++) {
      formData.append('dealers', this.selectedDealer[i]);
    }

    //Divisions
    for (let i = 0; i < this.selectedDivision.length; i++) {
      formData.append('divisions', this.selectedDivision[i]);
    }
    console.log(formData);
    this.baseAPI.callUploadDataApi(formData, this.baseAPI.uploadNotificationURL).then(data => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(data));
      var msg = jsonObj.msg;
      alert(msg);

      this.router.navigate(['/dashboard']);
    }, (err) => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));

      alert(jsonObj.msg);
    });
  }


  callUpdateNotificationApi() {
     this.spinnerService.show();
     let formData: FormData = new FormData();
     formData.append('notification_type', this.editNotificationType);
     formData.append('notification_id', this.editNotificationId);
     formData.append('notification_title', this.editNotificationTitle);
     formData.append('notification_desc', this.editNotificationDescription);
     formData.append('start_date', this.editStartDate);
     formData.append('end_date', this.editEndDate);
     formData.append('is_published', this.editPublication);
     formData.append('notif_type_id', this.editNotificationTypeId);
     formData.append('created_by', this.editNotificationCreatedBy);

    //Images
     if (this.editFiles != undefined && this.editFiles.length != undefined) {
       for (let i = 0; i < this.editFiles.length; i++) {
         formData.append('files', this.editFiles[i]);
       }
     }


     //Rigion

     var splitedRigion=this.editNotificationRigions.split(",")

     for (let i = 0; i < splitedRigion.length; i++) {
      formData.append('regions', splitedRigion[i]);
    }


    var splitedSates=this.editNotificationStates.split(",")

    for (let i = 0; i < splitedSates.length; i++) {
     formData.append('states', splitedSates[i]);
   }


     //City

     var splitedCities=this.editNotificationCities.split(",")

     for (let i = 0; i < splitedCities.length; i++) {
      formData.append('cities', splitedCities[i]);
    }



     //Dealers

     var splitedDealers=this.editNotificationDealers.split(",")

      for (let i = 0; i < splitedDealers.length; i++) {
       formData.append('dealers', splitedDealers[i]);
     }


     //Divisions
     var splitedDivisions=this.editNotificationDivisions.split(",")

      for (let i = 0; i < splitedDivisions.length; i++) {
       formData.append('divisions', splitedDivisions[i]);
     }



    this.baseAPI.callUploadDataApi(formData, this.baseAPI.updateNotificationURL).then(data => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(data));
      var msg = jsonObj.msg;
      alert(msg);
      this.hideAllView();
       this.selectedCategory='View Notification'
      this.callViewNotificationApi();
    }, (err) => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));

      alert(jsonObj.msg);
    });

  }



  callGetNotificationById(notificationId) {
    this.baseAPI.readNotificationApi(this.baseAPI.notificationDetialByIdURL, notificationId).then(data => {

      document.getElementById('editNotification').style.display = 'block';

      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(data));

      this.editNotificationId = jsonObj.notifications[0].notification_id;
      this.editNotificationTitle = jsonObj.notifications[0].notification_title;
      this.editNotificationDescription = jsonObj.notifications[0].notification_desc;
      var is_published = jsonObj.notifications[0].is_published;
      this.editStartDate=jsonObj.notifications[0].start_date;
      this.editEndDate=jsonObj.notifications[0].end_date;
     this.editNotificationType=jsonObj.notifications[0].notfi_type;
     this.editNotificationTypeId=jsonObj.notifications[0].notfi_type_id;
     this.editNotificationCreatedBy=jsonObj.notifications[0].created_by;
    this.editNotificationRigions=jsonObj.notifications[0].regions;
    this.editNotificationStates=jsonObj.notifications[0].states;
    this.editNotificationCities=jsonObj.notifications[0].cities;
    this.editNotificationDealers=jsonObj.notifications[0].dealers;
    this.editNotificationDivisions=jsonObj.notifications[0].divisions;



      if (is_published === 'Y') {
        this.isChecked = true;
        this.isChecked1=false;
              }
      else if (is_published === 'N') {
        this.isChecked1=true;
        this.isChecked = false;
      }




    }, (err) => {

      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));
      var message = jsonObj.msg;
      if (message != undefined) {
        alert(message);
      }
      else {
        alert('Please try again');
      }
    });
  }


  callViewNotificationApi() {

    this.baseAPI.viewNotificationApi(this.baseAPI.viewNotificationURL).then(data => {



      document.getElementById('notification_table').style.display = 'block';

      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(data));

      this.data_NOTIFICATION = jsonObj.notifications;
      this.onChangeTable_NOTIFICATION(this.config_NOTIFICATION);


    }, (err) => {

      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));
      var message = jsonObj.msg;
      if (message != undefined) {
        alert(message);
      }
      else {
        alert('Please try again');
      }
    });
  }

  /**
   * Mehod to call read notification Api
   * @param notificationId
   */

  callReadNotificationApi(notificationId) {

    this.baseAPI.readNotificationApi(this.baseAPI.readNotificationURL, notificationId).then(data => {

      document.getElementById('read_notification_table').style.display = 'block';

      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(data));

      this.data_READ_NOTIFICATION = jsonObj.data;
      this.onChangeTable_READ_NOTIFICATION(this.config_READ_NOTIFICATION);


    }, (err) => {

      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));
      var message = jsonObj.msg;
      if (message != undefined) {
        alert(message);
      }
      else {
        alert('Please try again');
      }
    });
  }

  deleteNotificationApi(notificationId) {
    this.spinnerService.show();

    this.baseAPI.callDeleteNotificationApi(this.baseAPI.deleteNotificationURL, notificationId).then(data => {

      var jsonObj = JSON.parse(JSON.stringify(data));

      var message = jsonObj.msg;
      if (message != undefined) {
        alert(message);
      }

      this.callViewNotificationApi();

    }, (err) => {

      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));
      var message = jsonObj.msg;
      if (message != undefined) {
        alert(message);
      }
      else {
        alert('Please try again');
      }
    });
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen; // Toggle dropdown open/close
  }
}



// WEBPACK FOOTER //
// ./src/app/notification/notification.component.ts